/**
 * fix-173c (2026-09-25): FE-side gating for home-* module fetches.
 *
 * Backend /api/entitlements/me (F130 / fix-173b) strips unit-scope home-* ids
 * from BOTH `modules` and the legacy `features` array and sets
 * `usuariosOnly: true` for non-residente Propietarios. The FE must respect
 * that payload: when home-tasks / home-shopping are not entitled, skip the
 * /api/home/* calls entirely (no request, no 403 banner) and render the
 * neutral empty state instead. Users WITH the entitlement keep the exact
 * current behavior (regression guard: qa-residente-paid).
 *
 * Fail-open rule: when no entitlement payload is available (fetch error /
 * older backend shape), the gate allows the call — the backend remains the
 * authoritative 403 guard, so behavior degrades to today's, never worse.
 */
export interface HomeEntitlementShape {
  usuariosOnly?: boolean;
  modules?: string[];
  features?: string[];
}

export function homeModuleEntitled(
  ent: HomeEntitlementShape | null | undefined,
  moduleId: string
): boolean {
  if (!ent) return true;
  if (ent.usuariosOnly === true) return false;
  if (Array.isArray(ent.modules) && ent.modules.length > 0 && !ent.modules.includes(moduleId)) return false;
  // Legacy gate: backend `features` array (stripped in lockstep with modules).
  if (Array.isArray(ent.features) && ent.features.length > 0 && !ent.features.includes(moduleId)) return false;
  return true;
}
